import { render, staticRenderFns } from "./DebugQuestionnairesComponent.vue?vue&type=template&id=038188b0&"
import script from "./DebugQuestionnairesComponent.vue?vue&type=script&lang=js&"
export * from "./DebugQuestionnairesComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports